/* Fechas de la linea de tiempo del pedido.
   Vive aparte del configurador porque la misma banda se pinta en la ficha de
   producto, donde aquel script no se carga.

   Las fechas se calculan aqui y no en Liquid a proposito: una fecha escrita en
   el HTML se queda dentro de lo que cachea el CDN y al dia siguiente miente. */
(function () {
  'use strict';

  var cajas = document.querySelectorAll('[data-sx-timeline]');
  if (!cajas.length) return;

  /** Suma dias habiles saltando sabados y domingos. El almacen no despacha en fin de semana. */
  function sumarHabiles(desde, dias) {
    var f = new Date(desde.getTime());
    var quedan = Math.max(0, dias);
    while (quedan > 0) {
      f.setDate(f.getDate() + 1);
      var dia = f.getDay();
      if (dia !== 0 && dia !== 6) quedan--;
    }
    return f;
  }

  /** El transportista si se mueve en fin de semana, asi que el transito cuenta natural. */
  function sumarNaturales(desde, dias) {
    var f = new Date(desde.getTime());
    f.setDate(f.getDate() + Math.max(0, dias));
    return f;
  }

  /* Practicamente nadie reparte en domingo. Se empuja al lunes, que ademas es el
     lado seguro: una estimacion mas tardia nunca genera una reclamacion. */
  function evitarDomingo(f) {
    if (f.getDay() === 0) f.setDate(f.getDate() + 1);
    return f;
  }

  function fechaCorta(f) {
    return f.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  /** "Aug 26 - 28" si no cambia el mes, "Aug 26 - Sep 2" si cambia. */
  function rangoFechas(a, b) {
    if (a.getTime() === b.getTime()) return fechaCorta(a);
    var mesA = a.toLocaleDateString('en-US', { month: 'short' });
    var mesB = b.toLocaleDateString('en-US', { month: 'short' });
    if (mesA === mesB) return mesA + ' ' + a.getDate() + ' – ' + b.getDate();
    return mesA + ' ' + a.getDate() + ' – ' + mesB + ' ' + b.getDate();
  }

  Array.prototype.forEach.call(cajas, function (caja) {
    var proceso = Number(caja.getAttribute('data-proceso')) || 0;
    var min = Number(caja.getAttribute('data-transito-min')) || 0;
    var max = Number(caja.getAttribute('data-transito-max')) || 0;
    if (max < min) max = min; // un maximo por debajo del minimo no describe nada

    /* Dos relojes distintos: el almacen despacha en dias habiles, el transporte
       corre en dias naturales. Mezclarlos era lo que desplazaba la entrega. */
    var hoy = new Date();
    var envio = sumarHabiles(hoy, proceso);
    var textos = [
      fechaCorta(hoy),
      fechaCorta(envio),
      rangoFechas(evitarDomingo(sumarNaturales(envio, min)), evitarDomingo(sumarNaturales(envio, max)))
    ];

    Array.prototype.forEach.call(caja.querySelectorAll('[data-sx-fecha]'), function (destino) {
      var texto = textos[Number(destino.getAttribute('data-sx-fecha'))];
      if (texto) destino.textContent = texto;
    });
  });
})();
